import { useEffect, useState } from 'react';
import { BrowserRouter, Navigate, Outlet, Route, Routes } from 'react-router-dom';
import { useAuthContext } from './hooks/useAuthContext';


import { useCollection } from './hooks/useCollection';
import { COLLECTION_PATH } from './firebase/FirebaseConst';

//STYLES
import './App.css'

//COMPONENTS
import PassGenerator from './components/misc/PassGenerator';
import Home from './pages/bar/home/Home'
import TaskDetail from './pages/bar/task/TaskDetail';
import Category from './pages/bar/category/Category';
import Search from './pages/bar/search/Search';
import Header  from './components/bar/Header';
import Contact from './pages/bar/contact/Contact';
import Footer from './components/bar/Footer';
import { useData } from './hooks/useData';
import BarLayout from './components/layouts/BarLayout';
import AdminLayout from './components/layouts/AdminLayout';
import Login from './pages/login/Login'
import AdminBarTasks from "./pages/admin/admin-bar/tasks/AdminBarTasks";

function App() {
  const { data: cat } = useData('CATEGORIES')
  // const { data: rawTasks } = useData('TASKS')
  const { documents: rawTasks, error } = useCollection(COLLECTION_PATH.TASKS.COLLECTION)

  const [tasks, setTasks] = useState(null)
  const {user, authIsReady } = useAuthContext()

  useEffect( () => {
    if (rawTasks) {
      rawTasks.sort((t1, t2) => {
        if (t1.order < t2.order) {
          return -1
        } else if (t1.order > t2.order) {
          return 1
        }
        return 0
      })
      setTasks(rawTasks.map( t => {
        return{...t, completed: false}
      }))
    }
  },[rawTasks])

  return (
    <div className="App">
      {authIsReady && (<BrowserRouter>
          <Routes>
            {/* LOGIN */}
            <Route path='/login' element={ !user ? <Login/> : <Navigate to="/bar"/> }/>

            <Route path="/" element={ user ? <Navigate to="/admin"/> : <Navigate to="/login"/> } />

            {/* ADMIN */}
            <Route path='/admin' element={user ? <AdminLayout/> : <Navigate to="/login"/> } >
              <Route path='dashboard' element={<div>Admin content</div>} />
              <Route path='bar/tasks' element={<AdminBarTasks rawTasks={tasks}/>} />
            </Route>

            {/* BAR */}
            <Route path='/bar' element={user ? <BarLayout/> : <Navigate to="/login"/> } >
              <Route path='home' element={<Home categories={cat}/>} />
              <Route path='contact' element={<Contact/>}/>
              <Route 
                path='task/:id' 
                element={
                  <TaskDetail 
                    tasks={tasks} 
                    setTasks={setTasks}
                  />
                }
              />
              <Route 
                path='cat/:id' 
                element={
                  <Category 
                    tasks={tasks} 
                    categories={cat} 
                    setTasks={setTasks}
                  />
                }
              />
              <Route 
                path='search' 
                element={
                  <Search 
                    tasks={tasks}
                    cat={cat}
                  />
                }
              />
            </Route>
          </Routes>
      </BrowserRouter>)}
    </div>
  );
}

export default App;